import { Toaster_default as e } from "../../../node_modules/.pnpm/vue-sonner@2.0.0/node_modules/vue-sonner/lib/index.js";
import { createBlock as t, defineComponent as n, mergeProps as r, openBlock as i, unref as a } from "vue";
//#region src/components/ui/sonner/Sonner.vue?vue&type=script&setup=true&lang.ts
var o = /* @__PURE__ */ n({
	__name: "Sonner",
	props: {
		invert: { type: Boolean },
		theme: {},
		position: {},
		hotkey: {},
		richColors: { type: Boolean },
		expand: { type: Boolean },
		duration: {},
		gap: {},
		visibleToasts: {},
		closeButton: { type: Boolean },
		toastOptions: {},
		class: {},
		style: {},
		offset: {},
		mobileOffset: {},
		dir: {},
		swipeDirections: {},
		icons: {},
		containerAriaLabel: {}
	},
	setup(n) {
		let o = n;
		return (n, s) => (i(), t(a(e), r({ class: "toaster group" }, o, { style: {
			"--normal-bg": "var(--white)",
			"--normal-text": "var(--black)",
			"--normal-border": "var(--gray-border-1)"
		} }), null, 16));
	}
});
//#endregion
export { o as default };

//# sourceMappingURL=Sonner_vue.js.map